import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { FaPlus } from 'react-icons/fa'
import { ContentInner } from '../../../../../layout/Content'
import ModalWindow from '../../../../../layout/modalwindow/ModalWindow'
import UsersSchedulerForm from './forms/users_scheduler_form/UsersSchedulerForm'
import Schedule from './components/Schedule'
import { appContext } from '../../../../../../App'
import { usersSchedulerContext } from './UsersSchedulerController'
import './css/UsersSchedulerStyle.css'

function UsersScheduler(props) {
  const app = useContext(appContext)
  const clientUsers = app.client.users
  const usersSchedulerController = useContext(usersSchedulerContext)
  const initSchedule = usersSchedulerController.schedule[2]
  const [schedules, updateSchedules, deleteSchedule] = usersSchedulerController.schedules

  const cb = (sched) => {
    if (sched !== 'close') updateSchedules(sched)
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const showAddNewScheduleForm = (schedule) => {
    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        width='30'
        header={ schedule.id ? 'Change Schedule Title and Time' : 'New Schedule'}
        footer={null}>
        <UsersSchedulerForm cb={cb} schedule={schedule}/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickAddNewSchedule = (e) => { showAddNewScheduleForm(initSchedule) }

  const scheduleProps = {
    updateSchedules,
    deleteSchedule,
    showAddNewScheduleForm,
    clientUsers,
    time_zone: app.client.company_address.time_zone
  }

  return (
    <ContentInner>
      <div className='scheduler-title-header-container'>
        <div className='scheduler-title-header'>Sytem's Users Scheduler</div>
        <button className='scheduler-button-new' onClick={onClickAddNewSchedule}>
          <div className='fa-icon'><FaPlus/></div> <div className='button-caption'>New Schedule</div>
        </button>
      </div>
      <hr className='scheduler-thin-hr'/>
      {
        schedules.sort((a, b) => (b.id - a.id)).map((sched, i) => (
          <React.Fragment key={i}>
            <Schedule key={JSON.stringify(sched)} {...scheduleProps} schedule={sched}/>
            {((schedules.length - 1) !== i) ? <br/> : null}
          </React.Fragment>
        ))
      }
    </ContentInner>
  )
}

export default React.memo(UsersScheduler)